<template>
  <div class="avatar" :style="bg" :class="[size, { empty: !src }]">
    <Online :size="size" :online="online" />
    <slot></slot>
  </div>
</template>

<script>
import Online from '@/components/user/Online'

export default {
  name: 'Avatar',
  components: { Online },
  props: {
    src: String,
    online: {},
    size: String,
  },
  computed: {
    bg() {
      return {
        'background-image': `url('${this.src}')`,
      }
    },
  },
}
</script>

<style lang="scss">
.avatar {
  width: 69px;
  height: 69px;
  border-radius: 5px;
  background-color: rgba($dark, 0.3);
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  position: relative;
  flex-shrink: 0;

  &.size-auto {
    background-size: auto;
  }

  .online-status-dote {
    position: absolute;
    top: 0;
    right: 0;
  }

  &.xxl {
    width: 86px;
    height: 86px;
    border-radius: 20px;

    @include PC {
      width: 165px;
      height: 165px;
      border-radius: 20px;
    }
  }

  &.xl {
    width: 60px;
    height: 60px;
    border-radius: 10px;

    @include PC {
      width: 132px;
      height: 132px;
      border-radius: 15px;
    }
  }

  @include PC {
    &.lg-pc {
      width: 121px;
      height: 121px;
      border-radius: 10px;
    }
  }

  @mixin sm {
    width: 30px;
    height: 30px;
    border-radius: 5px;
  }

  &.m {
    width: 40px;
    height: 40px;
    border-radius: 5px;
  }

  &.sm {
    @include sm;
  }

  @include PC {
    &.sm-pc {
      @include sm;
    }
  }
}
</style>
